<ion-header>
  <ion-toolbar>
    <ion-title>{{ 'Score Update Subscription' | translate }}</ion-title>
    <ion-buttons slot="end">
      <ion-button color="dark" (click)="dismiss()">
        <ion-icon slot="icon-only" name="close"></ion-icon>
      </ion-button>
    </ion-buttons>
  </ion-toolbar>
</ion-header>
<ion-content *ngIf="isLoading" class="ion-padding">
  <ion-grid class="h-100">
    <ion-row class="ion-justify-content-center ion-align-items-center h-100">
      <ion-col size="auto">
        <ion-spinner name="crescent"></ion-spinner>
      </ion-col>
    </ion-row>
  </ion-grid>
</ion-content>
<ion-content class="ion-padding" *ngIf="!isLoading">
  <!-- Admin View -->
  <ng-container>
    <ng-container>
      <ion-item>
        <ion-label>{{ 'Select Subscription Partner' | translate }}: </ion-label>
        <ion-select [(ngModel)]="partner" interface="popover" [ngModel]="'select'">
          <ion-select-option value="select">{{ 'Select' | translate }}</ion-select-option>
          <ion-select-option *ngFor="let p of allPartners" [value]="p">{{ p }}</ion-select-option>
        </ion-select>
      </ion-item>

      <!-- OR Separator -->
      <div *ngIf="isUserAdmin" class="or-separator">
        <ion-text color="medium">— {{ 'OR' | translate }} —</ion-text>
      </div>

      <ion-item *ngIf="isUserAdmin">
        <ion-label position="stacked">{{ 'Enter Subscription Partner' | translate }}:</ion-label>
        <ion-input [(ngModel)]="subscriptionNote" placeholder="{{ 'Enter Subscription Partner' | translate }}"></ion-input>
      </ion-item>

      <!-- Validation Error -->
      <ion-text color="danger" *ngIf="showValidationError">
        <p class="ion-padding-start">{{ 'Please provide a subscription partner name to continue.' | translate }}</p>
      </ion-text>
    </ng-container>

    <!-- Submit Button -->
    <ion-button expand="block" (click)="submitAdminSubscription()">{{ 'Submit Subscription' | translate }}</ion-button>

  </ng-container>
  <!-- Already Subscribed Label -->
  <ion-label class="section-label" *ngIf="!tieId && !tournamentId">
    <ion-icon name="people-circle-outline" slot="start"></ion-icon>
    {{ 'Already Subscribed' | translate }}
  </ion-label>
  
  <ion-list *ngIf="!tieId && !tournamentId">
    <ion-item *ngFor="let partner of (match?.scoreSubscribers || [])">
      <ion-label>{{ partner }}</ion-label>
      <ion-col class="ion-text-right">
        <ion-button color="danger" fill="clear" size="small" (click)="unsubscribe(partner)">
          {{ 'Remove' | translate }}
        </ion-button>
      </ion-col>
    </ion-item>
  </ion-list>

  <!-- Tournament Already Subscribed Label -->
  <ion-label class="section-label" *ngIf="tournamentId">
    <ion-icon name="people-circle-outline" slot="start"></ion-icon>
    {{ 'Remove' | translate }}
  </ion-label>
  
  <ion-list *ngIf="tournamentId">
    <ion-item *ngFor="let partner of (tournamentScoreSubscribers || [])">
      <ion-label>{{ partner }}</ion-label>
      <ion-col class="ion-text-right">
        <ion-button color="danger" fill="clear" size="small" (click)="unsubscribeFromTournament(partner)">
          {{ 'Remove' | translate }}
        </ion-button>
      </ion-col>
    </ion-item>
  </ion-list>

  <!-- Tie Already Subscribed Label -->
  <ion-label class="section-label" *ngIf="tieId && !tournamentId">
    <ion-icon name="people-circle-outline" slot="start"></ion-icon>
    {{ 'Already Subscribed to Tie' | translate }}
  </ion-label>
  
  <ion-list *ngIf="tieId && !tournamentId">
    <ion-item *ngFor="let partner of (tieScoreSubscribers || [])">
      <ion-label>{{ partner }}</ion-label>
      <ion-col class="ion-text-right">
        <ion-button color="danger" fill="clear" size="small" (click)="unsubscribeFromTie(partner)">
          {{ 'Remove' | translate }}
        </ion-button>
      </ion-col>
    </ion-item>
  </ion-list>
</ion-content>